import { computed, ref, watch, provide, toRef, openBlock, createElementBlock, renderSlot } from "vue";
import { TAGS_ENUMS } from "../FhTitle/constants.mjs";
import { AccordionContextKey } from "./Symbols.mjs";
const _hoisted_1 = { class: "fh-accordion" };
const _sfc_main = {
  __name: "FhAccordion",
  props: {
    modelValue: {
      type: Array,
      default: void 0
    },
    divider: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: TAGS_ENUMS.H2,
      validator: (value) => Object.values(TAGS_ENUMS).includes(value)
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const isControlled = computed(() => props.modelValue !== void 0);
    const localModelValue = ref([]);
    watch(
      () => props.modelValue,
      (newVal) => {
        if (isControlled.value) {
          localModelValue.value = newVal;
        }
      },
      { immediate: true }
    );
    const toggleItem = (name) => {
      let newValue;
      const currentIndex = localModelValue.value.indexOf(name);
      if (currentIndex !== -1) {
        newValue = localModelValue.value.filter((item) => item !== name);
      } else {
        newValue = [...localModelValue.value, name];
      }
      if (isControlled.value) {
        emit("update:modelValue", newValue);
      } else {
        localModelValue.value = newValue;
      }
    };
    provide(AccordionContextKey, {
      modelValue: localModelValue,
      toggleItem,
      tag: toRef(props, "tag"),
      divider: toRef(props, "divider")
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "default")
      ]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=FhAccordion.mjs.map
